import { transparentize } from 'polished';
/**
 * add boxShadow based on a supplied color:
 * @example
 * ${({ theme }) => boxShadow(theme.color.black, 'focus', true)};
 * ${({ theme }) => boxShadow(theme.color.black, 'active', true)};

 */

export function boxShadow(color, state) {
  var isInset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return "\n    ".concat(state ? "&:".concat(state, " {") : '', "\n      box-shadow : ").concat(isInset ? 'inset ' : '', "0 0 0 3px ").concat(transparentize(0.35, color), ";\n      outline-color : transparent;\n      outline-style : solid;\n    ").concat(state ? '}' : '', "\n  ");
}